import { Mode, Path } from './profile.type';

export const routeMapping: Record<Mode, Path> = {
  institution: {
    view: '/hub/profile/view',
    home: '/hub/profile',
    reset: '/hub/profile/reset-password',
    edit: '/hub/profile/edit'
  },
  candidate: {
    view: '/home/profile/view',
    home: '/home/profile',
    reset: '/home/profile/reset-password',
    edit: '/home/profile/edit'
  },
  recruiter: {
    view: '/panel/profile/view',
    home: '/panel/profile',
    reset: '/panel/profile/reset-password',
    edit: '/panel/profile/edit'
  }
};
